/**
 * The API owns its versioning: the version is part of this URL, never derived in web code.
 * Bumping to v2 is a change to these strings only.
 * Test builds set REACT_APP_ENV=test; every other build uses production.
 */
const TEST_API_BASE_URL = 'https://test.api.carehivehub.com/api/v1';
const PRODUCTION_API_BASE_URL = 'https://api.carehivehub.com/api/v1';

const API_BASE_URL =
  process.env.REACT_APP_ENV === 'test' ? TEST_API_BASE_URL : PRODUCTION_API_BASE_URL;

export const getApiClientBaseUrl = (): string => API_BASE_URL;

/** Origin used for static assets served by the API (e.g. /uploads/...). */
export const getApiOrigin = (): string => new URL(API_BASE_URL).origin;
